import { getOrderApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { GetOrdersRequest, GetOrdersResponse } from '@/core/generated/api';

/** Загружает список заказов через контракт API */
export const orderListService = {
    /** Возвращает страницу заказов */
    async getList(request: GetOrdersRequest): Promise<GetOrdersResponse> {
        try {
            const response = await getOrderApi().getOrders({ getOrdersRequest: request });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
